var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "25 65 215 135",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .statusFill {\n            fill: #2A6FAE;\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer3",
    transform: "matrix(10,0,0,10,-70,-70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18146,0,0,1.18146,8.05203,17.9282)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.028,
    cy: 5.139,
    r: 2.539,
    className: "statusFill"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18146,0,0,1.18146,22.0601,17.9282)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.028,
    cy: 5.139,
    r: 2.539,
    className: "statusFill"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.736065,1.02149e-16,-8.01262e-17,-0.741429,36.277,26.3223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.396,15.945L16.332,15.945C16.032,15.945 15.767,15.75 15.681,15.465C14.749,12.381 11.896,2.938 11.896,2.938C11.788,2.582 11.409,2.379 11.05,2.486C10.691,2.593 10.487,2.969 10.594,3.326C10.594,3.326 13.448,12.769 14.38,15.852C14.638,16.708 15.432,17.294 16.332,17.294L19.396,17.294C19.771,17.294 20.076,16.992 20.076,16.62C20.076,16.247 19.771,15.945 19.396,15.945Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.54471,0,0,2.02631,-12.5161,-17.6763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.067,19.047L16.18,18.981C16.76,18.644 17.563,18.643 18.143,18.98L18.52,19.198C18.814,19.369 19.209,19.397 19.539,19.272C19.87,19.147 20.079,18.891 20.079,18.609C20.079,17.818 20.079,16.744 20.079,16.126C20.079,15.93 19.977,15.741 19.794,15.603C19.612,15.464 19.365,15.386 19.108,15.386L15.224,15.386C14.687,15.386 14.253,15.717 14.253,16.126L14.253,20.074C14.253,20.483 14.687,20.814 15.224,20.814L21.386,20.814C21.681,20.814 21.96,20.712 22.144,20.536C22.617,20.087 23.822,18.938 24.319,18.464C24.525,18.268 24.587,18.006 24.482,17.767C24.297,17.344 23.946,16.541 23.946,16.541C23.89,16.412 23.707,16.342 23.537,16.385C23.368,16.428 23.276,16.568 23.332,16.698C23.332,16.698 23.683,17.5 23.868,17.923C23.903,18.003 23.883,18.09 23.814,18.156C23.814,18.156 21.639,20.228 21.639,20.228C21.577,20.287 21.484,20.321 21.386,20.321L15.224,20.321C15.045,20.321 14.9,20.21 14.9,20.074C14.9,20.074 14.9,16.126 14.9,16.126C14.9,15.99 15.045,15.879 15.224,15.879C15.224,15.879 19.108,15.879 19.108,15.879C19.194,15.879 19.276,15.905 19.337,15.952C19.397,15.998 19.431,16.061 19.431,16.126L19.431,18.609C19.431,18.703 19.362,18.789 19.252,18.83C19.141,18.872 19.01,18.862 18.912,18.806L18.535,18.587C17.723,18.116 16.598,18.117 15.788,18.589C15.717,18.63 15.674,18.655 15.674,18.655C15.533,18.737 15.505,18.892 15.614,19.001C15.722,19.109 15.925,19.13 16.067,19.047Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.5,0,0,0.5,23,5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,20L10,20C8.895,20 8,20.895 8,22C8,23.105 8.895,24 10,24L12,24L12,20Z",
    className: "statusFill"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourier);
export default __webpack_public_path__ + "static/media/courier.47b0dbae395daaa862e88a106fa1b34e.svg";
export { ForwardRef as ReactComponent };